<template>
  <div class="content">
    <!-- 人员体温填报（修改）  -->
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>疫情管控</el-breadcrumb-item>
            <el-breadcrumb-item>人员体温</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 侧边树 -->
      <el-aside width="15%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            node-key="id"
            highlight-current
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px" >
            <div class="grid-search">
              <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker>
              <el-input v-model="search.personName" style="width:200px" placeholder="请输入人员姓名" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div style="display:flex;margin:0px 0px 0px 0px;width: 20%;justify-content: space-between;align-items:center">
              
            </div>
          </div>
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.personName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="班组">
                <template slot-scope="scope">
                  <span>{{ scope.row.teamsName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="体温" width="300">
                <template slot-scope="scope">
                  <div style="height:40px;">
                    <span style="font-size:14px;border-bottom: 1px solid #666;">请填写您的体温</span> 
                    <span style="top: 8px;left: 5px;">℃</span>
                    <el-button type="primary" plain icon="el-icon-edit" size="mini" style="position: absolute;right: 0.5vw;" @click="modInfo(scope.row)"></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="打卡时间" prop="clockTime">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="打卡照片" width="200">
                <template slot-scope="scope">
                  <div style="text-align: center;">
                    <img
                      v-if="scope.row.photoFile!=''"
                      :src="scope.row.photoFile"
                      style="width:3.5vw;height:9vh;"
                    />
                    <div
                      v-else
                      style="width:3.5vw;height:9vh;background: #ddd;display: flex;align-items: center;justify-content: center;"
                    >暂无图片</div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.outFlag=='0' && isMenuExit('pro:worker:out')" size="mini" type="danger" plain style="margin-top:0.5vh;margin-bottom:0.5vh;" @click="handleDelete(scope.$index,scope.row)">离职</el-button>
                  <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)" style="margin-top:0.5vh;margin-bottom:0.5vh;">个人档案</el-button>
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">考勤信息</el-button>
                </template>
              </el-table-column> -->
              
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="人员修改" :visible.sync="modifyVisible" append-to-body>
              <el-form
                :model="workerInfo"
                ref="workerInfo"
                label-width="160px"
                label-position="right"
                :rules="rules"
              >
                <el-form-item label="姓名：">
                  <p>{{workerInfo.name}}</p>
                </el-form-item>
                <el-form-item label="体温：" prop="temperature">
                  <el-input type="number" v-model="workerInfo.temperature" autocomplete="off" style="width:10vw;"></el-input> ℃
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo('workerInfo')">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [],
      search: {
        //查询
        name: '',
        projectId: '',
        date:util.myTime.getCurTime(),
        temperatureType:'2',
        teamsId: '',
        entId: '',
        personName: '',
      },
      groupId: '',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dataText: '数据加载中...',
      personStu: '0',
      Phone: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      modifyVisible: false,
      workerInfo: {
        id: '',
        temperature: '',
      },
      rules:{
        temperature:[
          { required: true, message: '请输入体温', trigger: 'blur' },
        ]
      },
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
  },
  mounted() {
    this.search.projectId = this.groupId
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    this.teamTree() //获取组织树
    // this.getData()
  },
  methods: {
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      // this.search.personStatus = index
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.selectTemperature(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.List.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].photoFile =
                list[i].photoFile && list[i].photoFile != ''
                  ? base.httpCtx + list[i].photoFile
                  : ''
            }
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.List.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    
    //修改人员信息
    modInfo(row) {
      this.modifyVisible = true
      this.workerInfo.name = row.personName
      this.workerInfo.id = row.id
      this.workerInfo.temperature = ''
    },
    
    //获取数据名称
    getNameById(id, list) {
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      if (data.type == '1') {
        this.search.entId = data.parentId
        this.search.teamsId = ''
      } else if (data.type == '0') {
        this.search.entId = ''
        this.search.teamsId = data.id
      } else {
        this.search.entId = ''
        this.search.teamsId = ''
      }
      this.getData()
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp
        .getEntTeams({
          projectId: this.search.projectId
        })
        .then(function(resp) {
          //console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            var tree = util.common.listToTree('id', 'parentId', list)
            var obj = [{ name: '全部', id: '', parentId: '', children: [] }]
            obj[0].children = tree
            that.dataTree = obj
            // console.log(that.dataTree)
            if(tree.length>0){
              var curKey = tree[0].id
              that.search.entId = curKey
              that.currentNodekey = curKey
              that.expandedkeys.push(curKey)
              setTimeout(function () {
                that.$refs.tree.setCurrentKey(curKey)
              }, 100)
              that.getData()
            }else{
              this.dataText = '暂无数据'
            }
          }
        })
    },
    watchInput(e) {
      this.search.personStatus = e
      this.getData()
    },
    
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          myHttp.updateTemperature(that.workerInfo).then(function(resp){
            console.log(resp)
            if(resp.data.code=='200'){
              that.$message.success('提交成功')
              that.modifyVisible = false
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
    })
    },

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }
  .content >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .build-table {
    height: calc(100% - 140px);
  }
  .cur{
    background: #ECF5FF !important;
    color:#409EFF !important  ;
  }
  div >>> .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center !important;
  }
  .send >>> .el-dialog__header {
    text-align: left !important;
  }
  div >>> .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: center;
    box-sizing: border-box;
  }
  div >>>.el-input-group--append .el-input__inner{
    width: 200px;
  }
  .dialog_send{
    margin:10px 0px 10px 35px;
  }
  .dialog_end{
    padding:30px 0px 10px 35px;
    display: flex;
    justify-content: flex-end;
  }
  .else{
    justify-content: space-between;
    border-top: 1px dotted #ECF5FF;
  }
  .tips{
        display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
  }
</style>